export default __webpack_public_path__ + "static/spiritual-christian-shrines-1-847f96f7cc1c71e99fc7545d56f49ba5.jpg";